/** @jsx jsx */

import React, { useCallback, useState } from 'react';
import { jsx } from '@emotion/core';
import useNavigationHelpers from 'hooks/useNavigationHelpers';
import Button from 'components/Button';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { Box } from '@material-ui/core';
import useTranslate from 'hooks/useTranslate';
import ReactDOM from 'react-dom';

interface BackButtonContainerContext {
  container: HTMLDivElement | null;
  setContainer: (el: HTMLDivElement) => void;
}

export const BackButtonContext = React.createContext<BackButtonContainerContext | null>(
  null,
);

export const BackButtonContextProvider: React.FC = ({ children }) => {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);
  return (
    <BackButtonContext.Provider value={{ container, setContainer }}>
      {children}
    </BackButtonContext.Provider>
  );
};

export const BackButtonContainer = () => {
  return (
    <BackButtonContext.Consumer>
      {context => {
        if (context) {
          return <div ref={context.setContainer} id="backButton"></div>;
        }
      }}
    </BackButtonContext.Consumer>
  );
};

const BackButtonComponent: React.FC = ({ children }) => {
  const { goBack } = useNavigationHelpers();

  const t = useTranslate();
  const handleClick = useCallback(() => {
    goBack();
  }, [goBack]);

  return (
    <Box m={1}>
      <Button variant="text" onClick={handleClick} data-testid="back-button">
        <ChevronLeftIcon />
        {children ? children : t('backButton')}
      </Button>
    </Box>
  );
};

const BackButton: React.FC = ({ children }) => {
  return (
    <BackButtonContext.Consumer>
      {context => {
        if (context && context.container) {
          return ReactDOM.createPortal(
            <BackButtonComponent>{children}</BackButtonComponent>,
            context.container,
          );
        } else {
          return null;
        }
      }}
    </BackButtonContext.Consumer>
  );
};

export default BackButton;
